import React from 'react';

import SubtitleRegular from 'components/Typography/SubtitleRegular';
import {
  BLUE, DESSEM_APROVACAO_AMARELO_TEXTO, DESSEM_APROVACAO_VERDE, DESSEM_APROVACAO_VERDE_ESCURO,
  GRAY2, MEDIUM_BLUE,
} from 'constants/colors';
import { iniciais } from 'helper/Relatorios/Aprovacao';

import './index.scss';

export interface AvatarProps {
  nome: string | null;
  /** Cor de fundo explícita (ex.: `corDoEvento`); sem ela, deriva do nome. */
  cor?: string;
}

// tema: dados-inicio — cor de avatar (fundo forte com texto branco, legível nos dois temas)
const PALETA = [
  MEDIUM_BLUE, DESSEM_APROVACAO_VERDE, DESSEM_APROVACAO_AMARELO_TEXTO, BLUE,
  DESSEM_APROVACAO_VERDE_ESCURO,
];
// tema: dados-fim

/** Cor determinística a partir do nome, para variar visualmente os avatares. */
const corDoAvatar = (nome: string | null): string => {
  if (nome === null) return GRAY2; // tema: cor de dado
  const soma = nome.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return PALETA[soma % PALETA.length];
};

/** Círculo de 30px com as iniciais do autor (`null` → "SY", autor "Sistema"). */
export default function Avatar({ nome, cor = undefined }: AvatarProps) {
  return (
    <span
      className="relatorio-aprovacao-avatar"
      style={{ backgroundColor: cor ?? corDoAvatar(nome) }}
      title={nome ?? 'Sistema'}
    >
      <SubtitleRegular>{iniciais(nome)}</SubtitleRegular>
    </span>
  );
}
